module.exports = __webpack_public_path__ + "c7d943767440d4eb5ac9aebb65a8a774.png";